'use client'
import IconUse from '_/ui/icons/use'
import { Title } from '_/ui/title'
import Link from 'next/link'
import { tv, type VariantProps } from 'tailwind-variants'
import { Card } from './card'
import { useFetchGuides } from './use-fetch-guides'

const styles = tv(
	{
		slots: {
			base: 'w-full mb-10 print:hidden',
			title: 'text-primary-neutral mb-6',
			link: 'text-primary-neutral text-base font-bold flex items-center gap-2 mt-7 hover:text-secondary-neutral transition-color duration-300',
			guides: 'flex flex-wrap gap-7.5',
			guide: 'w-full max-[1634px]:last-of-type:hidden',
		},
		variants: {
			size: {
				md: {
					guides: 'gap-4',
					guide: 'max-w-xs w-[31%]',
					link: 'text-lg',
				},
			},
		},
	},
	{ responsiveVariants: ['md'] },
)

const { base, title, link, guides, guide } = styles({
	size: { md: 'md' },
})

export interface GuidesProps extends VariantProps<typeof styles> {
	className?: string
	slug: string
	theme: string
}

export const Guides = ({ className, slug, theme, ...rest }: GuidesProps) => {
	const { guidesList } = useFetchGuides({ tripSlug: slug })

	if (!guidesList || !guidesList.length) {
		return null
	}

	return (
		<section className={`${base()} ${className}`} {...rest}>
			<Title size='small' className={title()} asChild>
				<h3>Suggested Guides</h3>
			</Title>
			<ul className={guides()}>
				{guidesList?.map(guideInfo => (
					<li className={guide()} key={guideInfo.attributes.friendly_slug}>
						<Card
							excerpt={guideInfo.attributes.excerpt}
							destinationSlug={slug}
							createdDate={guideInfo.attributes.createdAt}
							theme={theme}
							slug={guideInfo.attributes.friendly_slug || guideInfo.attributes.slug || ''}
						/>
					</li>
				))}
			</ul>
			<Link
				href={`${process.env.NEXT_PUBLIC_SITE_URL}/${theme}/${slug}/guides`}
				className={link()}
				target='_blank'
				aria-label='View all Guides'
			>
				View all
				<IconUse id='arrow-right' width={24} height={24} fill='transparent' />
			</Link>
		</section>
	)
}
